export default function getBrowserPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
      return;
    }
    // Browser geolocation timeouts may exclude time spent waiting for permission.
    // Bound that wait too so browsing never depends on answering the prompt.
    let settled = false;
    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      callback(value);
    };
    const timer = setTimeout(() => finish(reject, {code: 3}), 11000);
    navigator.geolocation.getCurrentPosition(
      position => finish(resolve, position),
      error => finish(reject, error),
      {enableHighAccuracy: true, timeout: 10000, maximumAge: 0}
    );
  });
}
